import { render } from "./ApplicantHome.vue?vue&type=template&id=288d3be4&scoped=true"
import script from "./ApplicantHome.vue?vue&type=script&lang=ts"
export * from "./ApplicantHome.vue?vue&type=script&lang=ts"

import "./ApplicantHome.vue?vue&type=style&index=0&id=288d3be4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-288d3be4"
/* custom blocks */
import block0 from "./ApplicantHome.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script